import { useContext } from 'react';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AuthContext } from '@/context/auth-context';
import { getUserPats } from '@/services/user/get-user-pats';
import { UserPat } from '@/services/user/create-user-pat';

export const useGetUserPats = (
  options?: Omit<
    UseQueryOptions<UserPat[], Error, UserPat[]>,
    'queryKey' | 'queryFn'
  >,
) => {
  // Key by the signed-in user so a sign-out/sign-in (no page reload) never
  // serves the previous user's cached tokens within staleTime.
  const { user } = useContext(AuthContext);

  return useQuery<UserPat[], Error>({
    queryKey: ['user-pats', user?.id ?? null],
    queryFn: getUserPats,
    enabled: !!user?.id,
    ...options,
  });
};
